/**
 * Mot de passe d'un compte : la même règle à l'écran et sur le serveur
 * (activation, inscription, réinitialisation, changement, sous-traitant). Le
 * maximum borne le coût du hachage ; il n'est jamais imposé comme une forme.
 */
import { z } from 'zod';

export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 256;

export const passwordSchema = z
  .string()
  .min(PASSWORD_MIN_LENGTH, `Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères.`)
  .max(PASSWORD_MAX_LENGTH, `Le mot de passe ne peut pas dépasser ${PASSWORD_MAX_LENGTH} caractères.`);
